<template>
  <help>
    <template #language-switcher v-if="$feature.enableLanguagePreference && $languagePref?.browserLanguage === 'es'">
      <div class="flex">
        <div class="w-1/2 <md:hidden">
          &nbsp;
        </div>
        <language-switcher class="my-4 w-full md:w-1/2" />
      </div>
    </template>
  </help>
</template>

<script lang="ts" setup>
import help from '#commerce/pages/help.vue'
</script>
